<template>
  <div class="toggle">
    <div
      v-for="option in options"
      :key="option"
      class="option"
      :class="[storeValue == option ? 'selected' : '']"
      v-on:click="storeValue = option"
    >
      {{ option }}
    </div>
  </div>
</template>

<script>
export default {
  name: "Toggle",
  computed: {
    storeValue: {
      get() {
        let arr = this.store.split(".");
        let storeValue = this.$store.state;
        arr.forEach(element => (storeValue = storeValue[element]));
        return storeValue;
      },
      set(value) {
        this.$store.commit(this.mutation, value);
      }
    }
  },
  props: ["store", "options", "mutation"]
};
</script>

<style lang="stylus" scoped>
.toggle
  border-radius: 20px
  border: 1px solid #e5e5e5
  overflow: hidden
  width: auto
  height: auto
  .option
    padding: 10px 20px
    border-radius: 20px;
    float: left
    font-weight: 700;
    fluid font-size 16 14
    color: #ADADAD
    line-height: 100%;
    cursor: pointer
    transition: color 150ms
    fluid padding-top 10 5
    fluid padding-bottom 10 5
    &:not(.selected):hover
      color: #000
    &.selected
      background: #121844
      color: #FFF
      transition: none
</style>
